<template>
  <div>
    <div class="title">
      <div class="container box-series" :dir="localDisplayLang === 'ara' ? 'rtl' : 'ltr'">
        <div class="icon-text-wrapper">
          <h1 v-if="screen && screen.title" class="screen-title">{{ (localDisplayLang == "hi" || localDisplayLang == "hin") ? screen.title.hin : screen.title.eng }}</h1>
        </div>
      </div>
    </div>
    <div v-if="screenContent.length === 0">
      <div v-for="(i) in 7" :key="i">
        <categoriesPlaceholder :screen="screen"></categoriesPlaceholder>
      </div>
    </div>
    <div style="margin-top: -4.063rem;" class="grid-view" v-else>
      <noorPlayGrid
        :contents="screenContent"
        :section="screen"
        :playerInstance="playerInstance"
        :message="errorMessage"
        :isScrollable="isScrollable"
        @loadMore="loadMoreContents()"
      ></noorPlayGrid>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";

export default {
  props: {
    menuDetail: { type: Object },
    section: { type: [Object, String] },
    playerInstance: { type: Object },
    routeObject: { type: Object }
  },
  data() {
    return {
      loader: true,
      screenContent: [],
      errorMessage: null,
      localDisplayLang: null,
      page: 1,
      isScrollable: false,
      isMpegRequired: false,
      screen: null
    };
  },
  computed: {
    ...mapGetters(["appConfig"]),
  },
  watch: {
    $route() {
      this.screen = null;
      this.screenContent = [];
      this.page = 1;
      this.getContentScreen();
    },
  },
  created() {
    this.isMpegRequired = this.checkMpegRequired();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.screenContent = [];
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.localDisplayLang = this.localDisplayLang == 'hi' ? 'hin' : this.localDisplayLang;
    
    eventBus.$on("check-for-series-route", (data) => {
      this.localDisplayLang = data;
      this.loader = true;
      this.screen = null;
      this.screenContent = [];
      this.isScrollable = false;
      this.page = 1;
      this.getContentScreen();
    });

    this.getContentScreen();
  },
  mounted() {
    eventBus.$on("get-seeAll-data", (response) => {
      if (!response.reason) {
        if (this.screenContent && this.screenContent.length > 0) {
          this.screenContent = [...this.screenContent, ...response.data];
        } else {
          this.screenContent = [...response.data];
        }
        this.updateSEOMetadata(response);
        this.isScrollable = response.totalcount === this.screenContent.length ? false : true;
        this.loader = false;
      } else {
        this.loader = false;
        if (response.errorcode != 6066 && response.errorcode != 1001) {
          this.errorMessage = response.reason;
        }
      }
    });
  },
  methods: {
    checkMpegRequired() {
      const userAgent = navigator.userAgent || "";
      let isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
      // let isMpegRequired = false;
      // let videoTag = document.createElement("video");
      // let platformOs = navigator.platform;

      // if (videoTag.canPlayType("application/vnd.apple.mpegurl")) {
      //   if (platformOs.startsWith("Mac")) {
      //     isMpegRequired = true;
      //   }
      // }

      // return isMpegRequired;
      return isSafari;
    },
    updateSEOMetadata(response) {
  // Determine if it's Hindi based on localDisplayLang
  const isHindi = this.localDisplayLang === 'hin' || this.localDisplayLang === 'hi';

  // Get collection page name from screen.title
  const englishTitle = this.screen?.title?.eng ;
  const hindiTitle = this.screen?.title?.hin ; 

  // Define meta title as per the updated logic
  let metaTitle = this.screen?.title 
    ? (isHindi 
        ? `देखे ${this.screen.title.hin} वीडियो | अल्ट्रा प्ले ओटीटी`
        : `Watch ${this.screen.title.eng} Videos on Ultra Play OTT`)
    : document.title;

  // Define og:title and twitter:title per the requirement
  const metaOgTitle = isHindi
    ? `देखे ${hindiTitle} वीडियो | अल्ट्रा प्ले ओटीटी`
    : `Watch ${englishTitle} Videos on Ultra Play OTT`;
  const metaTwitterTitle = metaOgTitle;

  // Hardcode meta descriptions
  const metaDescription = isHindi
    ? `अल्ट्रा प्ले ओटीटी पर ${hindiTitle} वीडियो का ऑनलाइन स्ट्रीमिंग का आनंद लें या बाद में देखने के लिए ऐप डाउनलोड करें।`
    : `Enjoy online streaming of ${englishTitle} videos on Ultra Play OTT or download the app to watch later.`;
  const metaOgDescription = metaDescription;
  const metaTwitterDescription = metaDescription;

  // Define meta keywords dynamically based on title
  const metaKeywords = isHindi
    ? `${hindiTitle} वीडियो,`
    : `${englishTitle} videos,`;

  // Additional meta fields (unchanged)
  let metaOgImage = this.screen?.poster || "https://static-templates.firebaseapp.com/img/ultraplay_200x200.png";
  let metaOgImageWidth = "200";
  let metaOgImageHeight = "200";
  let metaOgUrl = location.href;

  // Update document title
  window.document.title = metaTitle;

  // Update meta tags
  this.setMetaTag("keywords", "name", metaKeywords);
  this.setMetaTag("description", "name", metaDescription);
  this.setMetaTag("og:title", "property", metaOgTitle);
  this.setMetaTag("twitter:title", "name", metaTwitterTitle);
  this.setMetaTag("og:description", "property", metaOgDescription);
  this.setMetaTag("twitter:description", "name", metaTwitterDescription);
  this.setMetaTag("og:image", "property", metaOgImage);
  this.setMetaTag("og:image:width", "property", metaOgImageWidth);
  this.setMetaTag("og:image:height", "property", metaOgImageHeight);
  this.setMetaTag("og:url", "property", metaOgUrl);
},
    setMetaTag(property, attribute, content) {
      let element = document.querySelector(`meta[${attribute}="${property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    },
    getContentScreen() {
      localStorage.setItem("playback_source", this.$router.currentRoute.params.section);
      let deckingconfig = localStorage.getItem("appDeckingConfig") ? JSON.parse(localStorage.getItem("appDeckingConfig")) : '';
      if (this.$router.currentRoute.params) {
        let section = this.$router.currentRoute.params.section;
        let screenData = deckingconfig?.screens[0]?.sections?.filter((item) => {
          let itemTitle = this.spacialCharEncoding(item?.title?.default);
          itemTitle = itemTitle?.toLowerCase();
          return itemTitle === section;
        });
        
        this.screen = screenData[0];
        this.getAllContents(this.isMpegRequired);
      }
    },
    getEndPoint() {
      const sectionType = this.screen.sectionType;
      const itemType = this.screen.itemType;
      
      if (sectionType == "ITEMLIST" && itemType == "CONTENT") {
        return "/subscriber/v1/content";
      } else if (sectionType == "ITEMLIST" && itemType == "TRAILERS") {
        return "/subscriber/v1/metadata/trailer";
      } else if (sectionType == "ITEMLIST" && itemType == "CASTNCREW") {
        return "/subscriber/v1/metadata/castncrew";
      } else {
        return "/subscriber/v1/content";
      }
    },
    getAllContents(isMpegRequired) {
      let payload = {
        endpoint: this.screen.endpoint || this.getEndPoint(),
        params: this.screen.parameters || this.screen.sectionData || {}
      };

      if (this.screen.sectionType == "ITEMLIST") {
        let item = this.screen.sectionData.map((data) => data.id);
        if (this.screen.itemType == "CONTENT") {
          payload.params = {
            contentlist: encodeURI(JSON.stringify(item)),
            orderby: {"objectid": item}
          };
        } else {
          payload.params = {
            contentlist: JSON.stringify(item)
          };
        }
      }

      payload.params.displaylanguage = this.localDisplayLang;
      payload.params.page = this.page;

      if (isMpegRequired) {
        payload.params.mpegtspackage = "YES";
      }

      let subscriberProfileDetails = JSON.parse(localStorage.getItem("subscriberProfileDetails") || "{}");
      if (subscriberProfileDetails?.kidsmode === "YES") {
        payload.params.genre = "Kids";
      }

      setTimeout(() => {
        eventBus.$emit("grid-see-all-data", payload);
      }, 500);
    },
    initialRoute() {
      this.$router.push({ name: "Home" });
    },
    loadMoreContents() {
      this.page = this.page + 1;
      this.getAllContents(this.isMpegRequired);
    },
  },
  components: {
    categoriesPlaceholder: () => import("@/components/placeholders/categoriesPlaceholder.vue"),
    noorPlayGrid: () => import("@/components/Templates/noorPlayGrid.vue"),
  },
  beforeDestroy() {
    this.screenContent = [];
    eventBus.$off("check-for-series-route");
    eventBus.$off("get-seeAll-data");
  },
  mixins: [Utility],
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "./screen.scss"
</style>